<template>
  <div class="recipe-flow">
    <div class="recipe-flow__station">
      <div class="recipe-flow__caption">Source</div>
      <div class="recipe-flow__node recipe-flow__node--source">
        <AutomationToolkitMark :slug="toolkitSlug" :name="toolkitName" :logo-url="toolkitLogoUrl" size="md" />
        <span class="recipe-flow__node-label">{{ toolkitName }}</span>
      </div>
    </div>

    <div class="recipe-flow__connector"><span /></div>

    <div class="recipe-flow__station">
      <div class="recipe-flow__caption">Action</div>
      <div class="recipe-flow__node recipe-flow__node--action">
        <i class="el-icon-position recipe-flow__icon" />
        <span class="recipe-flow__node-label">{{ actionLabel }}</span>
      </div>
    </div>

    <div class="recipe-flow__connector"><span /></div>

    <div class="recipe-flow__station">
      <div class="recipe-flow__caption">Aggregate</div>
      <div class="recipe-flow__node recipe-flow__node--agg">
        <i class="el-icon-data-line recipe-flow__icon" />
        <span class="recipe-flow__node-label">{{ aggregationLabel }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import AutomationToolkitMark from './AutomationToolkitMark.vue'

const AGG_VERB = {
  sum: 'Sum',
  count: 'Count',
  avg: 'Average',
  min: 'Min',
  max: 'Max',
}

export default {
  name: 'AutomationRecipeFlow',
  components: { AutomationToolkitMark },
  props: {
    toolkitSlug: { type: String, required: true },
    toolkitName: { type: String, required: true },
    toolkitLogoUrl: { type: String, default: '' },
    recipe: { type: Object, required: true },
  },
  computed: {
    actionLabel() {
      const slug = (this.recipe && this.recipe.action_slug) || ''
      // HUBSPOT_SEARCH_DEALS → Search deals
      const parts = slug.split('_').slice(1)
      if (!parts.length) return slug || 'Action'
      const verb = parts[0].charAt(0).toUpperCase() + parts[0].slice(1).toLowerCase()
      const rest = parts.slice(1).map(p => p.toLowerCase()).join(' ')
      return rest ? `${verb} ${rest}` : verb
    },
    aggregationLabel() {
      const pp = (this.recipe && this.recipe.post_processing) || {}
      const verb = AGG_VERB[pp.aggregation] || 'Aggregate'
      if (pp.aggregation === 'count') return 'Count records'
      const field = (pp.value_field || '').split('.').pop() || 'value'
      return `${verb} ${field}`
    },
  },
}
</script>

<style scoped>
.recipe-flow {
  display: flex;
  align-items: stretch;
  gap: 0;
  padding: 12px 0 4px;
}

.recipe-flow__station {
  display: flex;
  flex-direction: column;
  gap: 6px;
  flex: 0 1 auto;
  min-width: 0;
}

/* Stations are rendered inside the interpretation-card and need a slightly
   smaller eyebrow than the dialog-level aq-form-label spec — 10px instead of
   11px — but otherwise the same recipe (Lato 700, 0.08em, uppercase, #8a8a8a). */
.recipe-flow__caption {
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #8a8a8a;
}

.recipe-flow__node {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  background: #ffffff;
  border: 1px solid #e2e4ea;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 700;
  color: #1a1a1a;
  white-space: nowrap;
  min-height: 38px;
}

.recipe-flow__node--action,
.recipe-flow__node--agg {
  background: #fafbfc;
}

.recipe-flow__node-label {
  font-weight: 700;
  letter-spacing: 0.01em;
}

.recipe-flow__icon {
  font-size: 14px;
  color: #6c30cc;
}

.recipe-flow__connector {
  flex: 1 1 0;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 18px;
  position: relative;
  align-self: center;
  margin-top: 18px; /* offset for the caption row above the nodes */
  height: 38px;
}

.recipe-flow__connector span {
  display: block;
  width: 100%;
  height: 1px;
  background: #e2e4ea;
  position: relative;
}

.recipe-flow__connector span::after {
  content: '';
  position: absolute;
  right: -1px;
  top: -3px;
  width: 6px;
  height: 6px;
  border-top: 1px solid #e2e4ea;
  border-right: 1px solid #e2e4ea;
  transform: rotate(45deg);
}
</style>
